// React
import React from 'react';

// Styles
import styles from './Footer.module.scss';

// This component
export default function Footer() {
  // JSX
  return (
    <footer className={styles.wrapper}>
      <p className={styles.copyright}>Powered by Birchmark Solutions Inc.</p>
    </footer>
  );
}
